__webpack_require__.p = "/Data-Acadmy-react-/";